export class ErrorMessage {
    title: string;
    message: string;
    httpStatus: string;
}